<template>
  <div class="d-flex justify-content-evenly">
    <div  v-for="assessment in options">
      <div class="assessment hov-pointer" :class="{active: isActive(assessment)}"
           @click="selectAssessment(assessment)">
        <img alt="img" width="35" height="35" :src="assessment.description"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssessmentHorizontalSelect",
  props: {
    value: String | Object,
    options: Array | Object
  },
  watch: {
    value: function () {
      this.model = this.value
    },
    model: function (val) {
      this.$emit('input', val)
      this.$emit('change', val)
    }
  },
  data() {
    return {
      assessments: [],
      model: this.value
    }
  },
  methods: {
    selectAssessment: function (val) {
      if (this.isActive(val)) {
        return;
      }
      this.model = val;
      this.model.assessment_value = val.value;
    },

    loadAssessments() {
      if (this.options && this.options.length > 0) {
        this.assessments = this.options;
        return;
      }
      axios.get(`/settings/assessment`, {params: {limit: 100}})
          .then((result) => {
            this.assessments = result.data.data.data;
          });
    },
    isActive(assessment) {
      return Number(assessment.value) === Number(this.model?.assessment_value);
    }
  },
  mounted() {
    this.loadAssessments()
  }
}
</script>

<style scoped>
.assessment {
  text-align: center;
  padding: 12px;
  border-radius: 50%;
  transition: all 0.5s;
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  opacity: 0.5;
  min-width: 59px;
  min-height: 59px;
}
.assessment:hover {
  opacity: 1;
  -webkit-filter: grayscale(0);
  filter: grayscale(0);
}
.assessment.active {
  background: rgb(178, 230, 207);
  background: radial-gradient(circle, rgba(178, 230, 207, 0.49) 0%, rgba(178, 230, 207, 1) 100%);
  -webkit-filter: grayscale(0);
  filter: grayscale(0);
  opacity: 1;
}
img {
  object-fit: contain;
}
</style>
